import React from "react";

function DepAnnounceIcon() {
  return (
    <svg
      width="150%"
      height="150%"
      version="1.1"
      viewBox="0 0 800 800"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      fill="none"
      stroke="#f3f3f3"
      strokeWidth="16"
      strokeLinecap="round"
    >
      <g transform="matrix(1.33333 0 0 -1.33333 0 682.667)">
        <path d="M104.866 152.622l48.759 28.151-63.239 109.532-48.759-28.15c-30.246-17.463-40.609-56.139-23.147-86.386h.001c17.462-30.247 56.138-40.61 86.385-23.147z"></path>
        <path d="M200.544 413.61l49.832 55.779 138.335-239.602-235.086-49.014-63.239 109.533 50.203 56.194"></path>
        <path d="M418.406 221.83h0c10.397 6.003 13.96 19.298 7.957 29.695L288.028 491.127c-6.003 10.398-19.298 13.96-29.695 7.957h0c-10.397-6.003-13.959-19.298-7.957-29.695l138.335-239.602c6.003-10.398 19.298-13.96 29.695-7.957zM108.29 154.598l17.516-30.339c4.944-8.563 15.895-11.497 24.458-6.553l64.812 37.419c8.563 4.944 11.497 15.894 6.553 24.458l-6.561 11.364"></path>
        <path d="M206.62 150.244l52.967-91.741 13.279-8.888c5.879-3.935 5.59-12.672-.537-16.21l-38.32-22.124a9.552 9.552 0 00-13.048 3.497l-62.244 107.809M406.316 399.685l64.607 37.301M382.465 436.832l30.782 53.317M433 360.457h48.685M501.985 454.92h0M170.566 380.054h0"></path>
      </g>
    </svg>
  );
}

export default DepAnnounceIcon;
